/* Les vignettes des soins d'une boite composee, dans le panier.

   Le panier ne connait que des SKU : c'est ce que la page de composition colle
   sur la ligne (_ks_skus). Un SKU ne se resout pas en Liquid, la resolution se
   fait donc ici, par la recherche predictive, et le resultat est garde en
   sessionStorage pour ne pas redemander a chaque ouverture du tiroir.

   Regle de prudence : les NOMS des soins sont deja rendus par Liquid, depuis la
   propriete Contenu. Si cette resolution echoue, la composition reste lisible,
   elle perd seulement ses images. Rien ici ne touche au prix : le montant
   affiche est celui reellement paye, il vient de la ligne de panier. */
(function () {
  'use strict';

  var CLE = 'ks_vignettes_v1';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CLE) || '{}') || {}; } catch (e) { cache = {}; }

  function garde() {
    try { sessionStorage.setItem(CLE, JSON.stringify(cache)); } catch (e) {}
  }

  function largeur(u, px) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
  }

  function attends(ms) {
    return new Promise(function (f) { setTimeout(f, ms); });
  }

  /* Un SKU d'abord, un handle ensuite : la page de composition retombe sur le
     handle quand un soin n'a pas de SKU. */
  function tente(ref) {
    var u = '/search/suggest.json?q=' + encodeURIComponent(ref) +
            '&resources[type]=product&resources[limit]=1' +
            '&resources[options][fields]=variants.sku';
    return fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var p = d && d.resources && d.resources.results ? d.resources.results.products : null;
        if (p && p.length) {
          return { img: (p[0].featured_image && p[0].featured_image.url) || '', url: p[0].url || '' };
        }
        return fetch('/products/' + encodeURIComponent(ref) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (q) {
            return q ? { img: q.featured_image || '', url: '/products/' + q.handle } : null;
          });
      })
      .catch(function () { return null; });
  }

  /* Un echec n'est JAMAIS retenu. Le domaine repond 429 des que plusieurs
     resolutions s'enchainent, et mettre cet echec en cache condamnait la
     vignette pour toute la session, alors que le soin existe. On reessaie une
     fois, puis on renonce pour cette ouverture seulement. */
  function resout(ref) {
    if (cache[ref]) return Promise.resolve(cache[ref]);
    return tente(ref)
      .then(function (v) {
        return v || attends(700).then(function () { return tente(ref); });
      })
      .then(function (v) {
        if (v && v.img) { cache[ref] = v; garde(); }
        return v;
      });
  }

  function peint(hote) {
    var refs = (hote.getAttribute('data-skus') || '').split(',');
    var suite = Promise.resolve();
    refs.forEach(function (ref, i) {
      ref = (ref || '').trim();
      if (!ref) return;
      var boite = hote.querySelector('[data-ks-rang="' + i + '"]');
      if (!boite || boite.querySelector('img')) return;
      /* En file, pas en salve : une boite peut porter douze soins et le domaine
         repond 429 des qu'on enchaine trop vite. */
      suite = suite.then(function () {
        return resout(ref).then(function (v) {
          if (!v || !v.img || boite.querySelector('img')) return;
          var im = new Image();
          im.src = largeur(v.img, 96);
          im.alt = '';
          im.loading = 'lazy';
          im.decoding = 'async';
          boite.appendChild(im);
          boite.className += ' ks-boite__vignette--pleine';
        }).then(function () { return attends(140); });
      });
    });
  }

  /* ------------------------------------------------------- depart au paiement

     La boite est encaissee par le prestataire externe, pas par le checkout
     Shopify. Le bloc de layout/theme.liquid qui s'en charge ne s'arme que sur les
     pages de campagne ; /cart et le tiroir n'en sont pas. Sans cette
     interception, le bouton de commande enverrait la cliente ailleurs que la ou
     l'argent doit aller. On ne change donc PAS la destination, on la conserve :
     c'est le meme lien, avec le meme sub7, que celui que la page de composition
     construisait avant que le panier s'ouvre.

     Trois verrous avant de detourner quoi que ce soit :
     - une seule ligne « boite » dans le panier, et rien d'autre (data-seule) ;
     - un montant qui tombe exactement sur un palier connu ;
     - la table des liens presente.
     Si l'un des trois manque, on ne touche a rien et le parcours normal de la
     boutique reprend la main. */
  var SORTIES = [
    '[name="checkout"]',
    '.cart__checkout-button',
    'a[href^="/checkout"]',
    'a[href*="/cart/checkout"]',
    '.shopify-payment-button__button'
  ].join(',');

  function lienDeLaBoite() {
    var n = document.querySelectorAll('ks-boite-contenu');
    if (n.length !== 1) return null;
    var el = n[0];
    if (el.getAttribute('data-seule') !== '1') return null;
    if (typeof window.__KS_BOITE_URL__ !== 'function') return null;
    var cts = parseInt(el.getAttribute('data-palier'), 10);
    if (!cts) return null;
    var skus = el.getAttribute('data-skus') || '';
    var lst = skus.split(',').filter(function (x) { return x.trim(); });
    var nb = lst.length;
    /* Un lot de N exemplaires du meme soin repart comme avant : « handle xN » dans
       sub7, pour que le colis soit prepare avec la bonne quantite. */
    var qte = parseInt(el.getAttribute('data-qte'), 10) || 1;
    if (qte > 1 && lst.length === qte) { skus = lst[0].trim() + ' x' + qte; }
    /* La vignette que le partenaire affichera : la premiere que ce meme fichier a
       reussi a resoudre. Si aucune n'est encore la, le lien part sans image, il
       ne part jamais sans montant. */
    var im = el.querySelector('.ks-boite__vignette img');
    return window.__KS_BOITE_URL__(cts, skus, nb, im ? im.getAttribute('src') : '');
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest(SORTIES);
    if (!el) return;
    var u = lienDeLaBoite();
    if (!u) return;
    e.preventDefault();
    e.stopPropagation();
    /* La composition a servi, l'etat du plateau peut partir. */
    try { localStorage.removeItem('ks_boite_v1'); } catch (x) {}
    window.location.href = u;
  }, true);

  if (!window.customElements.get('ks-boite-contenu')) {
    window.customElements.define('ks-boite-contenu', class extends HTMLElement {
      connectedCallback() { peint(this); }
    });
  }
})();
